import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from "rxjs/operators";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs";
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { DialogService } from 'src/app/shared/services/dialog.service';

interface empresa {
  cantCursos: number,
  cantInstructores: number,
  cantVentas: number,
  categorias: string[],
  creador: string,
  descripcion: string,
  enlaceLinkedin: string,
  fechaCreacion: Date,
  foto: string,
  fotoFondo: string,
  nombre: string,
  publicado: boolean,
  resumen: string,
  sitioWeb: string,
  ultimaEdicion: Date,
  ultimoEditor: string,
}

@Component({
  selector: 'app-form-empresas',
  templateUrl: './form-empresas.component.html',
  styleUrls: ['./form-empresas.component.css']
})
export class FormEmpresasComponent implements OnInit {

  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    public router: Router,
    private storage: AngularFireStorage,
    public dialogService: DialogService
  ) { }

  //spinner
  loaded = 0

  // infomacion del adminstrador:
  usuario = JSON.parse(localStorage.getItem('user'))

  // Si vamos a editar entonces debe tener un id en la ruta
  id = this.route.snapshot.paramMap.get('id');

  empresa: empresa = {
    cantCursos: 0,
    cantInstructores: 0,
    cantVentas: 0,
    categorias: [],
    creador: '',
    descripcion: '',
    enlaceLinkedin: '',
    fechaCreacion: new Date,
    foto: '',
    fotoFondo: '',
    nombre: '',
    publicado: true,
    resumen: '',
    sitioWeb: '',
    ultimaEdicion: new Date,
    ultimoEditor: '',
  }

  // auxiliares para cargar fotos
  downloadURL: any;
  fire: any;

  // FLAG
  editar = 0;

  ngOnInit(): void {
    this.verificarEdicionOCreacion();
  }

  verificarEdicionOCreacion() {
    if (this.id == null) {
      this.inicializarCrearEmpresa();
    } else {
      this.inicializarEditarEmpresa();
    }
  }

  // INICIALIZACION DE CREAR EMPRESA

  inicializarCrearEmpresa() {
    this.editar = 0;
    this.loaded = 1;
  }

  /// INICIALIZACION DE EDICION DE EMPRESA //

  inicializarEditarEmpresa() {
    this.editar = 1
    this.cargarEmpresa();
  }

  cargarEmpresa() {
    this.afs.collection('empresas').doc(this.id).ref.get().then(doc => {
      const empresa = doc.data();
      this.empresa = {
        cantCursos: empresa['cantCursos'], //
        cantInstructores: empresa['cantInstructores'],
        cantVentas: empresa['cantVentas'],
        categorias: empresa['categorias'],
        creador: empresa['creador'],
        descripcion: empresa['descripcion'],
        enlaceLinkedin: empresa['enlaceLinkedin'],
        fechaCreacion: empresa['fechaCreacion'],
        foto: empresa['foto'], //
        fotoFondo: empresa['fotoFondo'],
        nombre: empresa['nombre'],
        publicado: empresa['publicado'],
        resumen: empresa['resumen'],
        sitioWeb: empresa['sitioWeb'],
        ultimaEdicion: empresa['ultimaEdicion'],
        ultimoEditor: empresa['ultimoEditor'],
      }
      this.loaded = 1;
    }).catch(error => {
      console.log(error)
      alert('No se ha podido guardar la empresa')
    });
  }

  /// FUNCIONALIDADES ///////////////////////////////

  cargarFoto(event, campo) {
    const file = event.target.files[0];
    let nombre = file.name
    nombre = nombre.replace(' ','-')
    const filePath = `Empresas/${this.id}/${nombre}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Empresas/${this.id}/${nombre}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL(); //Donde se usa este download URL?
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }  //'fire' se usa?
            console.log(this.fire)
            if (campo == "foto") {
              this.empresa.foto = url;
            }
            if (campo == "fotoFondo") {
              this.empresa.fotoFondo = url;
            }
          });
        })
      )
      .subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  guardarEmpresa() {
    /// Empresa nuevo creado
    if (this.editar == 0) {
      this.id = this.empresa.nombre.split(' ').join('-');
      this.empresa.creador = this.usuario.uid;

      this.empresa.fechaCreacion = new Date();
    }
    this.empresa.ultimaEdicion = new Date();
    this.empresa.ultimoEditor = this.usuario.uid;

    this.afs.collection('empresas').doc(this.id).set(this.empresa, { merge: true }).then(() => {
      this.dialogService.dialogExito().afterClosed().subscribe(res => {
        this.router.navigate(['admin/lista-empresas']);
      })
    }).catch(error => {
      this.dialogService.dialogFracaso()
      console.log(error)
    })

  }

  onDelete() {
    this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
      if (res == true) {
        this.afs.collection('empresas').doc(this.id).delete().then(() => {
          this.dialogService.dialogExito().afterClosed().subscribe(res => {
            this.router.navigate(['admin/lista-empresas']);
          })
        }).catch(error => {
          this.dialogService.dialogFracaso()
          console.log(error)
        });
      }
    });
  }
}
